module.exports = __webpack_public_path__ + "img/loudly-crying-face.39809ef2.png";